'use client';

import Script from 'next/script';
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect, useRef } from 'react';

const IS_DEV = process.env.NODE_ENV === 'development';
const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

function GA4Pageview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const initial = useRef(true);

  useEffect(() => {
    if (!pathname) return;
    if (initial.current) {
      initial.current = false;
      return;
    }
    const search = searchParams?.toString();
    const path = search ? `${pathname}?${search}` : pathname;
    window.gtag?.('event', 'page_view', { page_path: path });
  }, [pathname, searchParams]);

  return null;
}

export function GA4Provider() {
  if (!GA_ID || IS_DEV) return null;

  return (
    <>
      <Script
        id="ga4-src"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="lazyOnload"
      />
      <Script id="ga4-init" strategy="lazyOnload">
        {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js', new Date());gtag('config', ${JSON.stringify(GA_ID)}, { send_page_view: true });`}
      </Script>
      <Suspense fallback={null}>
        <GA4Pageview />
      </Suspense>
    </>
  );
}
